import Cookies from 'universal-cookie';
import { useRuntimeConfig } from 'virtual:runtime-config';

interface ConfigurableClient {
  interceptors: {
    request: {
      use: (handler: (request: Request) => Promise<Request>) => void;
    };
  };
  setConfig: (config: { baseUrl: string; credentials: RequestCredentials }) => void;
}

export const configureApiClient = (client: ConfigurableClient) => {
  const { VITE_RUNTIME_API_URL } = useRuntimeConfig()['experience-mf-listing'];
  const baseUrl = VITE_RUNTIME_API_URL;

  client.setConfig({ baseUrl, credentials: 'same-origin' });
  client.interceptors.request.use((request: Request): Promise<Request> => {
    if (request.headers) {
      const csrfTokenKey = 'x-csrftoken';
      const csrfToken = new Cookies('csrftoken').get('csrftoken');
      if (csrfToken) {
        request.headers.set(csrfTokenKey, csrfToken);
      }
      const requestedWithKey = 'x-requested-with';
      request.headers.set(requestedWithKey, 'XMLHttpRequest');
    }

    return new Promise((resolve) => {
      resolve(request);
    });
  });
};
